import {Helmet} from '@dr.pogodin/react-helmet';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, INVOICE_PREDEFINED_COLUMNS, useInvoiceActionCallback} from '@dms/shared';

export function InvoiceOverview() {
  const actionCallback = useInvoiceActionCallback();

  return (
    <>
      <Helmet title={i18n.t('page.accounting.invoiceList.title')} />
      <DmsDataGrid
        gridCode="invoicing"
        actionCallback={actionCallback}
        predefinedColumns={INVOICE_PREDEFINED_COLUMNS}
        data-testid={testIds.accounting.invoiceOverview('datagrid')}
      />
    </>
  );
}
